/**
 * UnknownIcon/index.js
 * desc: system icon for unknown step type
 * note: status icon via IconButton; defaults its tooltip + accessible name to the
 *       status label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const UnknownIcon = ({ tooltip, ...props }) => (
    <IconButton baseClassName="unknown icon" label={ tooltip || translate('icons.unknown.tooltip.text') } tooltip={ tooltip } { ...props }>
        <svg viewBox="0 0 12 18" xmlns="http://www.w3.org/2000/svg"><path d="M0 6c0-3.315 2.685-6 6-6s6 2.685 6 6c0 1.924-1.185 2.96-2.339 3.968C8.567 10.925 7.5 11.857 7.5 13.5h-3c0-2.732 1.413-3.815 2.656-4.767C8.13 7.985 9 7.319 9 6c0-1.65-1.35-3-3-3S3 4.35 3 6H0zm7.5 9v3h-3v-3h3z"/></svg>
    </IconButton>
);


export default UnknownIcon;
